// Showcase del tema "Clínico" (preview). Ruta /medical/design.
// Todo va envuelto en .theme-clinico (claro) y .theme-clinico.noche (oscuro),
// de modo que NO altera el resto del ERP en esta iteración.
import './clinico.css';
import { CitaPortalCard, EstadoClinico, PacienteClinico, PacienteClinicoCard, Panel } from './components';

const PACIENTE: PacienteClinico = {
  nombre: 'Eduardo Mosquera', edad: '52 años', genero: 'M', sangre: 'O+', identificacion: '0914020730',
  estado: 'urgente', alergias: 'Penicilina',
  motivo: 'Cefalea intensa de 2 días',
  vitales: { ta: '150/95', fc: '98', temp: '37.8', spo2: '96' },
};
const PACIENTE2: PacienteClinico = {
  nombre: 'María García', edad: '34 años', genero: 'F', sangre: 'A+', identificacion: '1712233445',
  estado: 'estable', motivo: 'Control prenatal',
  vitales: { ta: '110/70', fc: '74', temp: '36.6', spo2: '99' },
};

const SWATCHES = [
  ['Petróleo (primary)', 'bg-primary', 'text-primary-foreground'],
  ['Coral (acento)', 'bg-accent', 'text-accent-foreground'],
  ['Blanco cálido (bg)', 'bg-background border', 'text-foreground'],
  ['Pizarra (texto)', 'bg-foreground', 'text-background'],
];

function Lienzo({ noche = false }: { noche?: boolean }) {
  return (
    <div className={`theme-clinico ${noche ? 'noche dark' : ''} rounded-2xl border p-6 space-y-8`}
         style={{ background: 'hsl(var(--background))' }}>
      <header>
        <p className="text-sm text-muted-foreground">Tema {noche ? 'Clínico · Noche' : 'Clínico · Día'}</p>
        <h1 className="font-display text-3xl font-semibold text-foreground">Centro Médico</h1>
      </header>

      <Panel titulo="Color">
        <div className="grid grid-cols-2 sm:grid-cols-4 gap-2">
          {SWATCHES.map(([n, bg, fg]) => (
            <div key={n} className={`rounded-lg p-3 text-xs ${bg} ${fg}`}>{n}</div>
          ))}
        </div>
      </Panel>

      <Panel titulo="Estados clínicos (color + icono + texto)">
        <div className="flex flex-wrap gap-2">
          <EstadoClinico estado="urgente" />
          <EstadoClinico estado="estable" />
          <EstadoClinico estado="pendiente" />
          <EstadoClinico estado="completado" />
        </div>
      </Panel>

      <Panel titulo="Tipografía">
        <div className="space-y-1">
          <p className="font-display text-2xl text-foreground">Fraunces — títulos del portal</p>
          <p className="text-base text-foreground">IBM Plex Sans — cuerpo y datos clínicos densos</p>
          <p className="font-mono text-sm text-foreground">IBM Plex Mono — TA 120/80 · CIE-10 R51 · 0914020730</p>
        </div>
      </Panel>

      <Panel titulo="Vista clínica (densa)">
        <div className="grid gap-3 md:grid-cols-2">
          <PacienteClinicoCard p={PACIENTE} />
          <PacienteClinicoCard p={PACIENTE2} />
        </div>
      </Panel>

      <Panel titulo="Vista paciente (espaciosa)">
        <div className="max-w-md">
          <CitaPortalCard c={{ medico: 'Dr. Edward Zambrano', especialidad: 'Medicina General', fecha: 'Jueves 19 de junio', hora: '10:00', tipo: 'telematica' }} />
        </div>
      </Panel>
    </div>
  );
}

export function DesignShowcase() {
  return (
    <div className="p-6 space-y-6 max-w-5xl mx-auto">
      <div>
        <h1 className="text-xl font-semibold">Propuesta de diseño · Tema Clínico</h1>
        <p className="text-sm text-muted-foreground">Preview aislado (no afecta al resto del ERP). Petróleo + coral · Fraunces / IBM Plex · firma: la “columna clínica”.</p>
      </div>
      <Lienzo />
      <Lienzo noche />
    </div>
  );
}
